import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import DetailPageHeader from '../../pages/markets/component/detail-page-header';
import FuturesAndOptionsFaq from '../../pages/markets/component/futures-and-options-faq';
import FuturesExternalSearch from '../../pages/markets/component/futures-external-search';
import OpenInterestExternalWidget from '../../pages/markets/component/open-interest-external-widget';
import '../../pages/markets/pages/futures-external-open-interest/futures-external-open-interest.m.css';

const OpenInterestFull = () => {
  const queryClient = new QueryClient();
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        {initialLoading ? (
          <div styleName="initial-loading-container"></div>
        ) : (
          <div styleName="detail-header-container">
            <div className="container">
              <DetailPageHeader widget={true} />
            </div>
          </div>
        )}

        <div styleName="overall-container">
          <div styleName="search-widget-container" className="container">
            <FuturesExternalSearch />

            <OpenInterestExternalWidget widget={true} />
          </div>
        </div>
        <div className="container">
          <FuturesAndOptionsFaq widget={true} />
        </div>
      </>
    </QueryClientProvider>
  );
};

export default OpenInterestFull;
